module.exports = __webpack_public_path__ + "img/34.007db07c.jpg";